import React from 'react';
import { useLocation } from 'react-router-dom';
import { OrderType } from '../../models/order/OrderType';
import { ResponseCode } from '../../models/order/ResponseCode';
import EWalletTopUpInfo from './EWalletTopUpInfo';
import PurchaseCouponInfo from './PurchaseCouponInfo';
import { PenaltyPayInfo } from './PenaltyPayInfo';

const PaymentInfo = () => {
    const location = useLocation<Location>();
    const queryParams = new URLSearchParams(location.search);

    const responseCode = Number(queryParams.get('responseCode')) as ResponseCode;
    const orderType = Number(queryParams.get('orderType')) as OrderType;

    return (
        <>
            {
                orderType === OrderType.mPurse &&
                <EWalletTopUpInfo responseCode={responseCode} />
            }
            {
                orderType === OrderType.Coupon &&
                <PurchaseCouponInfo responseCode={responseCode} />
            }
            {
                orderType === OrderType.ePurse &&
                <EWalletTopUpInfo responseCode={responseCode} />
            }
            {
                orderType === OrderType.Penalty && 
                <PenaltyPayInfo responseCode={responseCode} />
            }
        </>
    );
}

export default PaymentInfo;
